import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useMediaQuery } from 'react-responsive';
import CoreValuesDesktop from '../../components/Desktop/CoreValuesDesktop';
import CoreValuesMobile from '../../components/Mobile/CoreValuesMobile';

const CoreValues = () => {
  const { language } = useLanguage();
  const result = useData();
  const about = result.data.about;
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 768 });

  const sharedProps = {
    about,
    language
  };

  return isMobile ? <CoreValuesMobile {...sharedProps} /> : <CoreValuesDesktop {...sharedProps} />;
};

export default CoreValues;